import React from 'react';
import { isFalsyString } from '@togglecorp/fujs';
import { TabContext } from '../TabContext.js';
import useHash from '../../hooks/useHash.js';
import { genericMemo, getHashFromBrowser } from '../../utils/index.js';

function Tabs(props) {
  const {
    children,
    variant = 'primary',
    disabled
  } = props;
  const [ellipsize, setEllipsize] = React.useState(false); // eslint-disable-next-line react/destructuring-assignment

  const defaultHash = props.useHash && isFalsyString(getHashFromBrowser()) // eslint-disable-next-line react/destructuring-assignment
  ? props.defaultHash : undefined; // eslint-disable-next-line react/destructuring-assignment

  const hash = useHash(props.useHash ? props.initialHash || defaultHash : undefined); // FIXME: destructuring here as props.value and props.onChange cannot be
  // added in dependency list
  // eslint-disable-next-line react/destructuring-assignment

  const onChange = !props.useHash ? props.onChange : undefined; // eslint-disable-next-line react/destructuring-assignment

  const value = !props.useHash ? props.value : undefined;
  const contextValue = React.useMemo(() => {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.useHash) {
      return {
        variant,
        disabled,
        hash,
        // eslint-disable-next-line react/destructuring-assignment
        useHash: props.useHash,
        ellipsize,
        setEllipsize
      };
    } // Note: following cast is required since we do not have any other method
    // to provide template in the context type


    return {
      variant,
      disabled,
      activeTab: value,
      setActiveTab: onChange,
      ellipsize,
      setEllipsize
    };
  }, [// eslint-disable-next-line react/destructuring-assignment
  props.useHash, value, onChange, variant, disabled, hash, ellipsize]);
  return /*#__PURE__*/React.createElement(TabContext.Provider, {
    value: contextValue
  }, children);
}
var index = genericMemo(Tabs);

export { Tabs, index as default };
//# sourceMappingURL=index.js.map
